<template>
  <div class="list-labor">
    <AppPageHeader title="Labor" :action="{ title: 'Add labor', to: { name: 'CreateLabor' } }"  />

    <BaseTable
      :is-loading="isPending"
      :items="results"
      :fields="tableFields"
      :paginate="true"
      :error="error"
      :next-page="nextPage"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPages"
      :number-per-page="numPerPage"
      :is-searchable="true"
      :clickable="true"
      @on-search="(val) => search(val)"
      @row-selected="onRowSelected"
    >
      <template #name-data="data">
        <span class="font-semibold text-slate-950">{{ data.row.name }}</span>
      </template>
      <template #hourlyRate-data="data">
        <span>{{ currency(data.row.hourlyRate) }} / hr</span>
      </template>
    </BaseTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import BaseTable from '@/components/base/BaseTable.vue'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import LaborService from '@/services/LaborService'
import { useSearchablePagination } from '@/composables/useSearchablePagination'
import { currency } from '@/utils'

const tableFields = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'hourlyRate', label: 'Hourly Rate', sortable: true },
  { key: 'description', label: 'Description' },
]

const numPerPage = ref(25)

const {
  results,
  isPending,
  error,
  search,
  currentPage,
  totalPages,
  totalRecords,
  nextPage,
  prevPage,
} = useSearchablePagination({
  indexName: 'labor',
  service: new LaborService(),
  numPerPage: numPerPage.value,
  defaultOrderBy: 'name',
  defaultOrderDir: 'asc'
})

const $router = useRouter()
const onRowSelected = (row: any) => {
  $router.push({ name: 'ShowLabor', params: { id: row.id } })
}

</script>
